// document.addEventListener("DOMContentLoaded", function() {
//   document.body.classList.add("popup_body_hidden");

//   const popup = document.querySelector(".rs_promo_popup");
//   const closeBtn = popup.querySelector(".rs_promo_popup-close");
//   const overlay = popup.querySelector(".rs_promo_popup-overlay");

//   function closePopup() {
//     popup.classList.add("hidden");
//     document.body.classList.remove("popup_body_hidden");
//   }

//   closeBtn.addEventListener("click", closePopup);
//   overlay.addEventListener("click", closePopup);
// });
// document.addEventListener("DOMContentLoaded", function() {
//   const popup = document.querySelector(".rs_promo_popup");
//   if (!popup) return;

//   const closeBtn = popup.querySelector(".rs_promo_popup-close");
//   const inner = popup.querySelector(".rs_promo_popup-inner");
//   const closedData = JSON.parse(localStorage.getItem("promo_popup_closed"));
//   const now = new Date().getTime();

//   if (closedData && now < closedData.expiry) {
//     popup.classList.add("hidden");
//     return;
//   } else {
//     localStorage.removeItem("promo_popup_closed");
//   }

//   document.body.classList.add("popup_body_hidden");

//   function closePopup() {
//     popup.classList.add("hidden");
//     document.body.classList.remove("popup_body_hidden");

//     const expiry = new Date().getTime() + 30 * 24 * 60 * 60 * 1000;
//     localStorage.setItem("promo_popup_closed", JSON.stringify({ expiry }));
//   }

//   closeBtn.addEventListener("click", closePopup);

//   popup.addEventListener("click", function(e) {
//     if (!inner.contains(e.target)) {
//       closePopup();
//     }
//   });
// });
document.addEventListener("DOMContentLoaded", function() {
  const popup = document.querySelector(".rs_promo_popup");
  if (!popup) return;

  const closeBtn = popup.querySelector(".rs_promo_popup-close");
  const inner = popup.querySelector(".rs_promo_popup-inner");

  const expiryDays = parseInt(popup.dataset.expiryDays) || 30;

  function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
  }

  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  if (getCookie("promo_popup_closed") === "true") {
    popup.classList.add("hidden");
    return;
  }

  document.body.classList.add("popup_body_hidden");

  function closePopup() {
    popup.classList.add("hidden");
    document.body.classList.remove("popup_body_hidden");
    setCookie("promo_popup_closed", "true", expiryDays);
  }

  closeBtn.addEventListener("click", closePopup);

  popup.addEventListener("click", function(e) {
    if (!inner.contains(e.target)) {
      closePopup();
    }
  });
});
